class ExportcsvService{
  startExport(productsList:any, name:string) {
    console.warn(productsList, 'errr');
    const csvContent = this.parseJsontoCsv(productsList);
    const data = encodeURIComponent(csvContent);
    const link = document.createElement('a');
    // if (window.navigator.msSaveOrOpenBlob) {
    //   const blobObject = name.includes('.xls') ? new Blob([data], { type: 'text/xls;charset=utf-8;' }) :
    //   new Blob([data], { type: 'text/csv;charset=utf-8;' });
    //   link.onclick = function () {
    //     window.navigator.msSaveOrOpenBlob(blobObject, name);
    //   };
    // }
    if (name.includes('.xls')) {
      link.href = name.includes('.xls') ? `data:text/xls;charset=utf-8,${data}` :
      `data:text/csv;charset=utf-8,${data}`;
      link.setAttribute('style', 'visibility:hidden');
      link.download = name;
    } else {
      link.href = `data:text/csv;charset=utf-8,${data}`;
      link.setAttribute('style', 'font-weight: bold');
      link.download = name;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  export(dataToExport:any, fileName:string) {
    const csvContent = this.parseJsontoCsv(dataToExport);
    const BOM = '\uFEFF';
    const blobObject = fileName.includes('.xls')
      ? new Blob([BOM + csvContent], { type: 'text/xls;charset=utf-8;' })
      : new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.download = fileName;
    link.href = URL.createObjectURL(blobObject);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  parseJsontoCsv(csvData:any) {
    let csv = ''; // tslint:disable-line
    // Object.keys(csvData[1])
    //             .forEach((item:any) => {
    //               csv = `${csv} ${item},`;
    //             });
    // csv += '\r\n';
    for (let row = 0; row < csvData.length; row += 1) {
      let keysAmount = Object.keys(csvData[row]).length;// tslint:disable-line
      let keysCounter = 0;// tslint:disable-line
      for (let key in csvData[row]) {// tslint:disable-line
        /*if (csvData[row][key].indexOf(',') !== -1) {
          csvData[row][key] = csvData[row][key].replace(/,/g, ' & ');
        }*/
        // retaining the comma within the value
        const val = `${csvData[row][key]}` === 'undefined' ? ' ' : `"${csvData[row][key]}"`;
        csv += (val + (keysCounter + 1 < keysAmount ? ',' : '\r\n'));
        keysCounter += 1;
      }
      keysCounter = 0;
    }
    return csv;
  }
}
export default new ExportcsvService();
